module.exports = __webpack_public_path__ + "assets/resstar3-0at2x.be64912a331d5fef8a335b66daad2fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar3-0at2x.png
// module id = 856
// module chunks = 0